import React from 'react';
import StepSixContent from '../../components/AssessmentsAndTests/StepSix/StepSixContent';
import DashboardLayout from "../../layout/DashboardLayout";


const AssessmentResult = () => {
  const resultId = new URLSearchParams(window.location.search).get('resultId');
  const retakeUrl: any = new URLSearchParams(window.location.search).get(
    'retakeUrl'
  );
  const retake = () => {
    (window as Window).location = retakeUrl || '/';
  };
  return (
    <DashboardLayout>
      <StepSixContent headerProgress={100} retake={retake} id={resultId || ''} />
    </DashboardLayout>
  );
};

export default AssessmentResult;
